import { render, staticRenderFns } from "./userform.vue?vue&type=template&id=0dc95870&scoped=true"
import script from "./userform.vue?vue&type=script&lang=js"
export * from "./userform.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=0dc95870&prod&scoped=true&lang=css&external"
import style1 from "./userform.vue?vue&type=style&index=1&id=0dc95870&prod&lang=scss&scoped=true"
import style2 from "./userform.vue?vue&type=style&index=2&id=0dc95870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc95870",
  null
  
)

export default component.exports